export const formatApiKeyExpiry = (value) => {
  if (!value) {
    return ''
  }

  try {
    return new Date(value).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
  } catch {
    return String(value)
  }
}
